import { createTypedSxStyles } from '@opengov/capital-mui-theme';

const barBase = {
  height: '12px',
  backgroundColor: '#bdbdbd',
  borderRadius: '100px',
} as const;

export const styles = createTypedSxStyles({
  container: {
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
    width: '125px',
  },
  xs: { ...barBase, width: '50%' },
  sm: { ...barBase, width: '65%' },
  md: { ...barBase, width: '80%' },
  lg: { ...barBase, width: '90%' },
  xl: { ...barBase, width: '100%' },
});
